import { IPackageTypeInitialState } from "../../../types/master/packageTypeInterface";
import { PackageTypeActionTypes, PackageTypeActions } from "../../actionTypes/master/packageTypeActionTypes";

const initialState: IPackageTypeInitialState = {
  packageTypeList: [],
  packageTypeData: {
    id: 0,
    package_type_label: "",
    slug: "",
    created_by: 0,
  },
  packageTypeListPageCount: 0,
};

export default function packageTypeReducer(state = initialState, action: PackageTypeActionTypes): IPackageTypeInitialState {
  switch (action.type) {

    case PackageTypeActions.SET_PARCEL_LIST:
      return {
        ...state,
        packageTypeList: action.payload,
      };

    case PackageTypeActions.SET_PARCEL_LIST_PAGE_COUNT:
      return {
        ...state,
        packageTypeListPageCount: action.payload
      };

    case PackageTypeActions.SET_PARCEL_DATA_BY_ID:
      return {
        ...state,
        packageTypeData: action.payload,
      };

    default:
      return state;
  }
}